
import { Options, Vue } from 'vue-class-component';

interface FGCEvent {
  game: string;
  registrationUrl: string;
  prizePoolRoute: string;
}

@Options({})
export default class FGCView extends Vue {
  events: FGCEvent[] = [
    {
      game: 'Tekken 8',
      registrationUrl: 'https://www.start.gg/BGGT8',
      prizePoolRoute: '/bgg_fgc/prize-pool/tekken8',
    },
  ];

  openRegistration(url: string): void {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
}
